import React from 'react';
import vinylSpin from '../../assets/images/vinyl-spin-2.gif'

export const LoadingSpinner = () => (
  <div className="relative flex items-center justify-center w-40 h-40 aspect-square bg-cover">
    <div
      style={{ backgroundImage: `url(${vinylSpin})` }}
      className="absolute top-0 left-0 z-10 items-center justify-center w-40 h-40 aspect-square bg-cover"
    />
    <div className="relative z-0 w-16 h-16 bg-amber-50 rounded-full"></div>
    <div className="absolute w-16 h-16">
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="64px" height="64px" viewBox="0 0 64 64" className="load-spin">
        <defs>
          <path id="circlePath" d="M 32, 32 m -12, 0 a 12,12 0 0,1 24,0 a 12,12 0 0,1 -24,0" />
        </defs>
        <g>
          <use xlinkHref="#circlePath" fill="none"/>
          <text fill="#000" className="text-black text-xs tracking-tight uppercase pangram-sans-bold">
            <textPath xlinkHref="#circlePath">Loading</textPath>
          </text>
        </g>
      </svg>
    </div>
  </div>
);

export default LoadingSpinner;